import { render, staticRenderFns } from "./HomeworkUpload.vue?vue&type=template&id=536efe18&scoped=true&"
import script from "./HomeworkUpload.vue?vue&type=script&lang=js&"
export * from "./HomeworkUpload.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkUpload.vue?vue&type=style&index=0&id=536efe18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536efe18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VFlex,VIcon,VLayout,VSubheader})
